/* eslint-disable react/prop-types */
import React from 'react';
import { View, StyleSheet, Text } from '@react-pdf/renderer';
import InvoiceTableRow from './InvoiceTableRow';

import englan from '../../../english.json';
import germanlan from '../../../german.json';
import frenchlan from '../../../french.json';
import malayalamlan from '../../../malayalam.json';
const borderColor = '#00519C';

const styles = StyleSheet.create({
	tableContainer: {
		marginTop: 24,
		borderWidth: 1,
		borderColor: '#3778C2',
		width: '100%'
	},

	container: {
		flexDirection: 'row',
		backgroundColor: '#00519C',
		color: '#fff',
		borderBottomWidth: 1,
		borderBottomColor: borderColor,
		paddingVertical: 4,
		alignItems: 'center',
	},

	
  
	Id: {
		width: '6%',
		borderRightWidth: 1,
		borderRightColor: borderColor,
		fontSize: 6,
		textAlign: 'center'
	},

	Name: {
		width: '10%',
		borderRightWidth: 1,
		borderRightColor: borderColor,
		fontSize: 6,
		textAlign: 'center'
	},

	Email: {
		width: '10%',
		borderRightWidth: 1,
		borderRightColor: borderColor,
		fontSize: 6,
		textAlign: 'center'
	},

	CellPhone: {
		width: '10%',
		borderRightWidth: 1,
		borderRightColor: borderColor,
		fontSize: 6,
		textAlign: 'center'
	},

	Usertype: {
		width: '10%',
		borderRightWidth: 1,
		borderRightColor: borderColor,
		fontSize: 6,
		textAlign: 'center'
	},

	Profile: {
		width: '11%', 
		borderRightWidth: 1,
		borderRightColor: borderColor,
		fontSize: 6,
		textAlign: 'center',
	},
});


const InvoiceItemsTable = (props) => {
	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? englan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? englan : langid == 6 ? malayalamlan : englan;
	return(
		<View style={styles.tableContainer}>
  
			<View style={styles.container}>
				<Text style={styles.Id}>{langdata && langdata.Id ? langdata.Id:'Id'}</Text>
				<Text style={styles.Name}>{langdata && langdata.Name ? langdata.Name:'Name'}</Text>
				<Text style={styles.Email}>{langdata && langdata.TotalDistance ? langdata.TotalDistance:'Total Distance'}</Text>
				<Text style={styles.CellPhone}>{langdata && langdata.CoveredDistance ? langdata.CoveredDistance:'Covered Distance'}</Text>
				<Text style={styles.Usertype}>{langdata && langdata.AvgVelocity ? langdata.AvgVelocity:'Avg Velocity'}</Text>
				<Text style={styles.Profile}>{langdata && langdata.Coverage ? langdata.Coverage:'Coverage'}</Text>
				<Text style={styles.Profile}>{langdata && langdata.IdleTime ? langdata.IdleTime:'Idle Time'}</Text>
				<Text style={styles.Profile}>{langdata && langdata.SpeedViolation ? langdata.SpeedViolation:'Speed Violation'}</Text>
				<Text style={styles.Profile}>{langdata && langdata.TotalTraveledDistance ? langdata.TotalTraveledDistance:'Total Traveled Distance'}</Text>
				<Text style={styles.Profile}>{langdata && langdata.Vehicle ? langdata.Vehicle:'Vehicle'}</Text>
				<Text style={styles.Profile}>{langdata && langdata.AllocationId ? langdata.AllocationId:'Allocation Id'}</Text>
				<Text style={styles.Profile}>{langdata && langdata.SystemGrade ? langdata.SystemGrade:'System Grade'}</Text>
				<Text style={styles.Profile}>{langdata && langdata.FinalGrade ? langdata.FinalGrade:'Final Grade'}</Text>
				<Text style={styles.Profile}>{langdata && langdata.StartTime ? langdata.StartTime:'Start Time'}</Text>
				<Text style={styles.Profile}>{langdata && langdata.EndTime ? langdata.EndTime:'End Time'}</Text>
			</View>

			<InvoiceTableRow data={props.invoice} />

		</View>

	);
};

export default InvoiceItemsTable;